import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {AddressRequestType} from "../types/address-request.type";

export const AddressesActions = createActionGroup({
  source: '[Address]',
  events: {

    //set address id
    setAddressId: props<{ id?: string, query?: Object, resolveType?: AddressRequestType }>()

  },
});
